import { render, staticRenderFns } from "./AdminNotificationBatchList.vue?vue&type=template&id=6025313c"
import script from "./AdminNotificationBatchList.vue?vue&type=script&lang=js"
export * from "./AdminNotificationBatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports